import clsx from "clsx"

export const TimeSlotSection = ({ currentSlots, setTimeValue, timeValue }) => {
   
    const isAvailable = (hour) => {
        const exists = currentSlots.find(item => {
            const dateObject = new Date(item).toLocaleTimeString('el-GR',{
                timeZone: 'Europe/Athens',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false, // Use 24-hour format
                hourCycle: 'h23' // Force 2-digit hours
              }).split(':')[0];

            return parseInt(dateObject) === hour
        })

        return exists
    }

    // Create a list of all hours in a day
    const allHours = Array.from({ length: 12 }, (_, index) => index);


    
    return (
        <div className="bg-white rounded-[12px] p-8 grid grid-cols-4 gap-1 max-lg:h-fit">
            {allHours.map(item => {
                const available = isAvailable(item + 8);
                return <div onClick={() => { available && setTimeValue(available); }} className={clsx('rounded-full flex justify-center py-1', available ? 'border border-[#A5A5A5] cursor-pointer' : 'bg-[#F5F5F7] opacity-80', timeValue === available && timeValue && 'text-white border-[#D4002A] bg-[#D4002A]')}>
                    {item + 8}:00
                </div>
            })
            }
        </div>
    )
}